export default {
    getAgentsDetails: state => state.agents,
    getAgent: state => state.agent,
    getStatistics: state => state.stats
}